import { render, staticRenderFns } from "./happygo_sso_return.vue?vue&type=template&id=ec715670&"
import script from "./happygo_sso_return.vue?vue&type=script&lang=js&"
export * from "./happygo_sso_return.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports